module.exports = "<div class=\"confirm-modal\">\r\n\t<p class=\"confirm-text\">\r\n\t\t<%= data.confirmText %>\r\n\t</p>\r\n\r\n\t<div class=\"buttons-wrapper\">\r\n\t\t<button class=\"btn btn-primary btn-ok\">\r\n\t\t\t<%- data.okText || 'OK' %>\r\n\t\t</button>\r\n\t\t<button class=\"btn btn-danger btn-cancel\">\r\n\t\t\t<%- data.cancelText || 'Cancel' %>\r\n\t\t</button>\r\n\t</div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/_modals/confirm-modal/confirm-modal.tpl.html
// module id = 63
// module chunks = 0